import {
  ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output
} from '@angular/core';

const TRUNCATE_LIMIT = 30;

@Component({
  selector: 'card',
  template: `<div class="card noselect" [class.inactive]="inactive" [class.selected]="selected" >
  <div class="card__cover">
    <img *ngIf="isImage" [src]="cover">
    <icon *ngIf="!isImage"
          [name]='cover'
          stroke="6"
          [color]="{
          '#000000': inactive,
          '#0279D4': selected,
          '#EEEEEE': !inactive && !selected
        }"
          size="70"></icon>
  </div>
  <div class="card__body">
    <h3 class="card__title">{{title}} <lke-id [id]="id" [color]="{
          '#cccccc': !inactive && !selected,
          '#000000': inactive,
          '#ffffff': selected
        }"></lke-id></h3>
    <div class="card__info text--small">
      <ng-content select="content"></ng-content>
    </div>
  </div>
</div>
`,
  styles: [`.card{display:inline-block;position:relative;box-sizing:border-box;height:275px;width:250px;margin:20px;border-radius:10px;background-color:#f8f8f8;border:1px solid #cbcbcb;box-shadow:0 2px 4px rgba(0,0,0,.16);transition:all ease-in-out .2s;overflow:hidden}.card .card__cover{position:relative;height:125px}.card .card__cover img{width:100%;position:relative}.card .card__cover icon{display:block;padding:30px 30px 0}.card .card__body{margin-top:-20px;position:relative;padding:0 30px 30px;height:175px;box-sizing:border-box}.card .card__body .card__title{font-size:22px;margin:0;padding-top:10px;word-break:break-all;text-transform:capitalize;color:#000}.card .card__body .card__info{position:absolute;left:30px;bottom:30px;color:#8e8e8e}.card .card__body .card__info b{color:#000}.card:hover{cursor:pointer;-webkit-transform:translateY(-10px);transform:translateY(-10px);transition:all ease-in-out .3s;box-shadow:0 14px 20px rgba(0,0,0,.1)}.card.selected{background-color:#0081e3;border:1px solid #0081e3;-webkit-transform:translateY(-10px);transform:translateY(-10px);transition:all ease-in-out .3s;box-shadow:0 12px 16px rgba(0,0,0,.16)}.card.selected .card__body .card__info,.card.selected .card__body .card__info b,.card.selected .card__title{color:#fff}.card.inactive{pointer-events:none;opacity:.5}.card.inactive .card__title{color:#878787}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent implements OnInit {

  @Input('id') id: string | number;
  @Input('cover') cover: string;
  @Input('title') title: string;
  @Input('selected') selected: boolean;
  @Input('inactive') inactive: boolean;
  @Output('sgClick') sgClick: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Output('dbClick') dbClick: EventEmitter<string | number> = new EventEmitter<string | number>();

  public isImage: boolean;

  constructor() {}

  public ngOnInit() {
    this.isImage = ( this.cover.indexOf('http') >= 0 );
    this.title = this.truncateTitle();
  }

  private truncateTitle(): string {
    let suffix = '\u2026';
    let strTitle = '' + this.title;

    if ( this.title === undefined || this.title === null ) {
      return this.title;
    }
    if (strTitle.length <= TRUNCATE_LIMIT) {
      return strTitle;
    }
    return strTitle.substring(0, Math.ceil(TRUNCATE_LIMIT / 2))
      + suffix + strTitle.substring(this.title.length - Math.floor(TRUNCATE_LIMIT / 2)
      );
  }

  @HostListener('click')
  public click() {
    this.sgClick.emit(this.id);
  }

  @HostListener('dblclick')
  public doubleClick() {
    this.dbClick.emit(this.id);
  }

}
